import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import log from '../../../helpers/logger'
import { auth, getCurrentUser } from '../../../helpers/auth'
import { getTimeStamp, getUUIDV4 } from '../../../helpers/utils'
import { createFile_cover_url_list } from '../../../services/File_cover_url_listService'
import { updateIssueCoverInfo } from '../../../services/IssueService'
import * as firebase from 'firebase';
import { storageRef, firebaseStorageBookCoverFolder } from '../../../config/constants'

function setErrorMsg(error) {
  return {
    registerError: error.message
  }
}

export default class UploadPageBookCover extends Component {

  constructor(props) {
    super(props);
    this.state = {
      registerError: null,
      currentUser: null,
      isLoading: true,

      file_name: '',
      selectorFiles: null,
      upload_result: 'Ready for upload.',
      file_uploaded_link: '--',

      file_name_via_url: '',
      file_url: '',
      upload_result_via_url: 'Ready for upload.',
      file_uploaded_link_via_url: '--',
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleInputFileChange = this.handleInputFileChange.bind(this);
    this.handleSubmitFileUpload = this.handleSubmitFileUpload.bind(this);
    this.updateProgress = this.updateProgress.bind(this);

    // via url
    this.handleSubmitFileUploadViaUrl = this.handleSubmitFileUploadViaUrl.bind(this);
    this.updateProgressViaUrl = this.updateProgressViaUrl.bind(this);
  }

  componentWillMount() {
    log.debug('componentWillMount')
  }
  async componentDidMount(){
    log.debug('componentDidMount')
    let user = await getCurrentUser();

    log.debug(user.displayName)

    this.setState({issue_id: this.props.match.params.issue_id})

    this.setState({currentUser: user})
    this.setState({owner_id: user.uid})

    this.setState({file_name: getUUIDV4()})
    this.setState({file_name_via_url: getUUIDV4()})

    log.debug('all data is loaded.')
    this.setState({isLoading: false})
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    // bind all input to setState
    this.setState({
      [name]: value
    });
    log.debug(this.state)

  }

  handleInputFileChange(selectorFiles: FileList) {

    log.debug(selectorFiles);
    this.setState({
      selectorFiles: selectorFiles
    });

  }

  updateProgressViaUrl(progress){
    this.state.pg_url.style = 'width: '+progress+'%'
  }

  updateProgress(progress){
    this.state.pg.style = 'width: '+progress+'%'
  }

  async handleSubmitFileUploadViaUrl(event){
    event.preventDefault();

    log.debug('upload book cover via url.')
    log.debug(this.state.file_name_via_url)
    log.debug(this.state.file_url)

    var fileUrl = this.state.file_url

    if (fileUrl === null) {
        alert('Must enter valid url begining with http or https');
        return;
    }

    if (fileUrl === "" || !fileUrl.match("^http")) {
        log.debug(fileUrl)
        alert('Must enter valid url begining with http or https');
        return;
    } else {
      log.debug('ok pass')
      var filename = fileUrl.substring(fileUrl.lastIndexOf("/") + 1).split("?")[0];
      var ext = filename.substr(filename.lastIndexOf('.') + 1);
      var saveFileName = this.state.file_name_via_url + "." + ext

      log.debug(filename);
      log.debug(fileUrl);
      log.debug(saveFileName);

      var xhr = new XMLHttpRequest();
      xhr.open("GET", fileUrl, true);
      xhr.responseType = "arraybuffer";

      let thisMett = this; // js closure to fixed this in callback or in promise.

      xhr.onload = function(e) {
          // Obtain a blob: URL for the image data.
          var arrayBufferView = new Uint8Array(this.response);
          var blob = new Blob([arrayBufferView], {
              type: "image/jpeg"
          });
          var urlCreator = window.URL || window.webkitURL;
          var imageUrl = urlCreator.createObjectURL(blob);
          //var img = document.querySelector( "#photo" );
          //img.src = imageUrl;
          log.debug(blob);
          var metadata = {
              'contentType': "image/jpeg"
          };
          var uploadTask = storageRef.child(firebaseStorageBookCoverFolder+'/' + saveFileName).put(blob, metadata);

          // Listen for state changes, errors, and completion of the upload.
          uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
              function(snapshot) {
                  // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                  var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                  log.debug('Upload is ' + progress + '% done');
                  //pg_url.style.width = progress + "%";
                  thisMett.updateProgressViaUrl(progress)

                  switch (snapshot.state) {
                      case firebase.storage.TaskState.PAUSED: // or 'paused'
                          console.log('Upload is paused');
                          break;
                      case firebase.storage.TaskState.RUNNING: // or 'running'
                          console.log('Upload is running');
                          break;
                  }
              },
              function(error) {
                  console.log(error);
                  alert(error);
                  switch (error.code) {
                      case 'storage/unauthorized':
                          // User doesn't have permission to access the object
                          break;
                      case 'storage/canceled':
                          // User canceled the upload
                          break;
                      case 'storage/unknown':
                          // Unknown error occurred, inspect error.serverResponse
                          break;
                  }
              },
              function() {
                log.debug('upload successfully')

                var downloadURL = uploadTask.snapshot.downloadURL;
                let saveFileCover = {
                  file_url: downloadURL,
                  filename: saveFileName,
                  issue_id: thisMett.state.issue_id,
                  date_created: firebase.firestore.FieldValue.serverTimestamp(),
                }

                log.debug(saveFileCover)
                createFile_cover_url_list(saveFileCover).then(function(fileCover){
                  log.debug(fileCover)
                  //var _URL = window.URL || window.webkitURL;
                  var img = new Image();
                  img.onload = function () {
                    log.debug(this.width + " " + this.height);
                    var width_cover = this.width;
                    var height_cover = this.height;
                    // update issue cover width height
                    updateIssueCoverInfo(thisMett.state.issue_id, this.width, this.height, downloadURL).then(function(issue){
                      log.debug("Document successfully updated!");
                      thisMett.setState({
                        upload_result_via_url:'Upload success.',
                        file_uploaded_link_via_url: downloadURL
                      })
                    })
                  }
                  img.src = imageUrl
                })

              });

    }
    xhr.send();

    }

  }

  async handleSubmitFileUpload(event) {
    event.preventDefault();

    log.debug('upload book cover.')
    log.debug(this.state.file_name)

    if(this.state.selectorFiles == null){
      log.debug('file is null')
      alert('Please select file to upload.')
      return
    }

    //this.state.pg.style = 'width: 90%'

    var file = this.state.selectorFiles[0]

    log.debug(file)
    var extension = file.name.substring(file.name.lastIndexOf('.')+1);
    var saveFileName = this.state.file_name+"."+extension
    var metadata = {
      'contentType': file.type
    };

    log.debug(extension)
    log.debug(saveFileName)
    log.debug(metadata)

    // Upload file and metadata to the object 'images/mountains.jpg'
    var uploadTask = storageRef.child(firebaseStorageBookCoverFolder+'/' + saveFileName).put(file, metadata);

    let self = this; // js closure to fixed this in callback or in promise.

    // Listen for state changes, errors, and completion of the upload.
    uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
      function(snapshot) {
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
        var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        log.debug('Upload is ' + progress + '% done');
        //self.state.pg.style = 'width: '+progress+'%'
        self.updateProgress(progress)

        switch (snapshot.state) {
          case firebase.storage.TaskState.PAUSED: // or 'paused'
            log.debug('Upload is paused');
            break;
          case firebase.storage.TaskState.RUNNING: // or 'running'
            log.debug('Upload is running');
            break;
        }
      }, function(error) {
        log.debug(error);
        alert(error);
        switch (error.code) {
          case 'storage/unauthorized':
            // User doesn't have permission to access the object
            break;
          case 'storage/canceled':
            // User canceled the upload
            break;
          case 'storage/unknown':
            // Unknown error occurred, inspect error.serverResponse
            break;
        }
    }, function() {
      log.debug('upload successfully')

      var downloadURL = uploadTask.snapshot.downloadURL;
      let saveFileCover = {
        file_url: downloadURL,
        filename: saveFileName,
        issue_id: self.state.issue_id,
        date_created: firebase.firestore.FieldValue.serverTimestamp(),
      }

      log.debug(saveFileCover)
      createFile_cover_url_list(saveFileCover).then(function(fileCover){
        log.debug(fileCover)
        var _URL = window.URL || window.webkitURL;
        var img = new Image();
        img.onload = function () {
          log.debug(this.width + " " + this.height);
          var width_cover = this.width;
          var height_cover = this.height;
          // update issue cover width height
          updateIssueCoverInfo(self.state.issue_id, this.width, this.height, downloadURL).then(function(issue){
            log.debug("Document successfully updated!");
            self.setState({
              upload_result:'Upload success.',
              file_uploaded_link: downloadURL
            })
          })
        }
        img.src = _URL.createObjectURL(file);
      })

    });


  }

  render () {

    let content;

    if (this.state.isLoading) {
      content = <div>Loading...</div>;
    } else {
      content =
      <div>
          <h4 className="page-header">
            <Link className="" to={`/issue/view/${this.state.issue_id}`}>back to issue</Link> &gt;
          Upload File: Cover
        </h4>
          <div id="result" className="alert alert-success">
              {this.state.upload_result}
          </div>
          <div id="linkbox" className="alert alert-info">
            {this.state.file_uploaded_link}
          </div>
          <div className="progress progress-striped active">
              <div id="pg" className="progress-bar progress-bar-success" role="progressbar"
                aria-valuenow={0} aria-valuemin={0} aria-valuemax={100}
                style={{width: '0%'}}
                ref={ref => this.state.pg = ref}
                >
              </div>
          </div>
          <form className="form-horizontal" role="form" onSubmit={this.handleSubmitFileUpload}>
              <div className="form-group">
                  <label htmlFor="file_name" className="col-sm-2 control-label">file_name:</label>
                  <div className="col-sm-4">
                        <input className="form-control"
                          type="text"
                          name="file_name"
                          value={this.state.file_name}
                          onChange={this.handleInputChange}
                          placeholder="file_name" readOnly/>
                  </div>
              </div>
              <div className="form-group">
                  <label htmlFor="state" className="col-sm-2 control-label">File input:</label>
                  <div className="col-sm-4">
                      <input type="file" onChange={ (e) => this.handleInputFileChange(e.target.files) } />
                  </div>
              </div>
              <button type="submit" className="btn btn-default">Upload</button>
              <button type="reset" className="btn btn-default">Reset</button>
          </form>
          <hr /> Upload via URL
          <div id="result" className="alert alert-success">
              {this.state.upload_result_via_url}
          </div>
          <div id="linkbox" className="alert alert-info">
            {this.state.file_uploaded_link_via_url}
          </div>
          <div className="progress progress-striped active">
              <div id="pg_url" className="progress-bar progress-bar-success"
                role="progressbar" aria-valuenow={0} aria-valuemin={0} aria-valuemax={100}
                style={{width: '0%'}}
                ref={ref => this.state.pg_url = ref}>
              </div>
          </div>
          <form className="form-horizontal" role="form" onSubmit={this.handleSubmitFileUploadViaUrl}>
              <div className="form-group">
                  <label htmlFor="file_name" className="col-sm-2 control-label">file_name:</label>
                  <div className="col-sm-4">
                    <input className="form-control"
                      type="text"
                      name="file_name_via_url"
                      value={this.state.file_name_via_url}
                      onChange={this.handleInputChange}
                      placeholder="file_name_via_url" readOnly/>
                  </div>
              </div>
              <div className="form-group">
                  <label htmlFor="file_url" className="col-sm-2 control-label">file_url:</label>
                  <div className="col-sm-4">
                    <input className="form-control"
                      type="text"
                      name="file_url"
                      value={this.state.file_url}
                      onChange={this.handleInputChange}
                      placeholder="file_url"/>
                  </div>
              </div>
              <button type="submit" className="btn btn-default">Upload</button>
              <button type="reset" className="btn btn-default">Reset</button>
          </form>
      </div>
    }


    return (
      <div>
          {content}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/UploadPage/UploadPageBookCover.js